import type { MutableRefObject } from "react";
import { useEffect, useRef } from "react";

type UseTrustPilotWidgetReturnType = {
  trustPilotContainerRef: MutableRefObject<HTMLDivElement | null>;
};

declare global {
  interface Window {
    Trustpilot: {
      loadFromElement: (element: Element, forceReload: boolean) => void;
    };
  }
}

export const loadTrustPilotWidgets = (): void => {
  if (typeof document === "undefined" || !window.Trustpilot) return;

  const elements = document.getElementsByClassName("trustpilot-widget");
  for (const element of elements) {
    window.Trustpilot.loadFromElement(element, false);
  }
};

export const useTrustPilotWidget = (): UseTrustPilotWidgetReturnType => {
  const trustPilotContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (window.Trustpilot && trustPilotContainerRef.current) {
      window.Trustpilot.loadFromElement(trustPilotContainerRef.current, false);
    }
  }, []);

  return {
    trustPilotContainerRef
  };
};
